import React, { FC } from 'react'
import classNames from 'classnames'
import { makeStyles, Theme } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

export type TStatStyle =
  | 'red'
  | 'green'
  | 'orange'
  | 'dark'
  | 'info'
  | 'error'
  | 'warning'
  | 'default'

interface LocationStatProps {
  statStyle: TStatStyle
  icon: JSX.Element
}

const useStatStyles = makeStyles<Theme, Pick<LocationStatProps, 'statStyle'>>(() => ({
  root: {
    position: 'relative',
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 20,
    height: 20,
    borderRadius: 20,
  },
  default: {
    border: `${brandColors.black} 1px solid`,
  },
  red: {
    backgroundColor: brandColors.error0,
    color: brandColors.error1,
  },
  green: {
    backgroundColor: brandColors.green2,
    color: brandColors.green1,
  },
  orange: {
    backgroundColor: brandColors.warning1,
    color: brandColors.warning0,
  },
  dark: {
    color: brandColors.coolGray8,
    backgroundColor: brandColors.coolGray4,
  },
  info: {
    color: brandColors.infoDark,
    backgroundColor: brandColors.infoMedium,
  },
  error: {
    color: brandColors.error,
    backgroundColor: brandColors.errorLight,
  },
  warning: {
    color: brandColors.warning,
    backgroundColor: brandColors.warningLight,
  },
}))

const LocationStat: FC<LocationStatProps> = ({ icon, statStyle }) => {
  const styles = useStatStyles({ statStyle })
  return (
    <div className={styles.root}>
      <div className={classNames(styles.badge, styles[statStyle])}>{icon}</div>
    </div>
  )
}

export default LocationStat
